module.exports = __webpack_public_path__ + "static/media/CustomerPortal.ae18c2cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo/CustomerPortal.png
// module id = 814
// module chunks = 0